import DateInput from "components/Form/dateInput";
import { FilterField } from "components/Form/filterSection";
import "./filterControls.css";

// "From / To" pair on one row for a date-range filter.
const DateRangeFields = ({ label, fromId, toId, fromValue, toValue, onFromChange, onToChange }) => (
  <FilterField label={label}>
    <div className="date-range">
      <DateInput
        id={fromId}
        label="From"
        aria-label={`${label} from`}
        value={fromValue || ""}
        onChange={(e) => onFromChange(e.target.value)}
      />
      <DateInput
        id={toId}
        label="To"
        aria-label={`${label} to`}
        value={toValue || ""}
        onChange={(e) => onToChange(e.target.value)}
      />
    </div>
  </FilterField>
);

export default DateRangeFields;
